module.exports = __webpack_public_path__ + "static/media/TajawalArabic.bb2e4ddc.woff";